import React, { createContext, useContext, useState, ReactNode } from "react";

interface MenuContextProps {
  title: string;
  setTitle: (title: string) => void;
}

const MenuContext = createContext<MenuContextProps | undefined>(undefined);

export const useMenu = () => {
  const context = useContext(MenuContext);
  if (!context) {
    throw new Error("erreur");
  }
  return context;
};

export const MenuProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [title, setTitle] = useState("Tableau de bord"); 

  return (
    <MenuContext.Provider value={{ title, setTitle }}>
      {children}
    </MenuContext.Provider>
  );
};
